export default __webpack_public_path__ + "static/media/bgLoginVector.be46fcd6.svg";